'use strict';

module.exports = require('./lib/get-tokens-from-props');
